<template>
  <div class="mine_top">
    <div class="main">
      <div class="mine_topBox flex">
        <img :src="userInfo.avatar" class="min_topTx" alt="" />
        <div class="flex_item">
          <div class="flex">
            <span class="mine_topName">{{userInfo.nickName}}</span>
            <p v-if="userInfo.userName != null" class="mine_topZh flex_item">账号：{{userInfo.userName}}</p>
          </div>
          <div class="flex mt18">
            <span class="mine_topLable">{{userInfo.deptName}}</span>
            <span class="mine_topLable">{{userInfo.dictMap?.classroomPeriod}}</span>
            <span class="mine_topLable">{{userInfo.dictMap?.classroomSubject}}</span>
          </div>
        </div>
        <div>
          <span class="mine_topXf">{{userInfo.realScore}}</span>
          <span class="mine_topXfLab">总学分</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    }
  }
};
</script>

<style scoped>
.mine_top {
  background-color: #3b4fd3;
  background: url(../../assets/uc_top_bg.png) no-repeat 100% center;
  height: 244px;
  margin-top: 64px;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.main {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  min-width: 1200px;
}

.mine_topBox {
  height: 244px;
}

.mt18 {
  margin-top: 18px;
}

.min_topTx {
  width: 130px;
  height: 130px;
  border: 2px solid #fff;
  border-radius: 50%;
  margin-right: 32px;
}

.mine_topName {
  font-size: 34px;
  color: #fff;
  font-weight: 600;
  line-height: 32px;
  margin-right: 16px;
}

.mine_topZh {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  line-height: 22px;
  font-weight: 400;
}

.mine_topLable {
  display: inline-block;
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  padding: 5px 16px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 57px;
  margin-right: 16px;
  font-weight: 400;
}

.mine_topXf {
  font-size: 34px;
  color: #fff;
  line-height: 40px;
  font-weight: bold;
  display: block;
  text-align: center;
}

.mine_topXfLab {
  margin-top: 6px;
  line-height: 22px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  display: block;
  text-align: center;
}
</style>